module.exports = __webpack_public_path__ + "img/brand-banner-bg.7ef3967.svg";